import React, { useEffect, useState } from "react";
import { IonButton, IonImg, IonText, useIonAlert } from "@ionic/react";
import {
	IonInput,
	IonItem,
	IonLabel,
	IonSelect,
	IonSelectOption,
	IonButtons,
	IonContent,
	IonHeader,
	IonMenuButton,
	IonPage,
	IonTitle,
	IonToolbar,
	IonCol,
	IonGrid,
	IonRow,
	IonIcon
} from "@ionic/react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, LinkButton } from "../../controls";
import { add, logInOutline } from "ionicons/icons";
import validator from "validator";
import imgLogo from "../../media/logo/logo.png";
import useStore from "../../store/store";
import AnimatedPage from "../AnimatedPage";

const Login = (props: any) => {
	const { t } = useTranslation();
	const { setIsLoggedIn, setIsLoading, setUser, setToken } = useStore(
		state => state
	);
	const history = useHistory();
	let [email, setEmail] = useState<string>("");
	let [password, setPassword] = useState<string>("");
	let [error, setError] = useState<string>("");
	let [msg, setMsg] = useState<string>("");
	let [isDisabled, setIsDisabled] = useState<boolean>(false);

	const submitData = () => {
		if (email === "") {
			setError(t("requiredEmail") || "");
			return;
		}
		if (password === "") {
			setError(t("requiredPassword") || "");
			return;
		}
		if (!validator.isEmail(email)) {
			setError(t("validEmail") || "");
			return;
		}

		setIsLoading("true");
		axios
			.post(`${process.env.REACT_APP_API_URL}/users/login`, {
				email,
				password
			})
			.then(res => {
				setIsLoggedIn("true");
				setUser(res.data.user);
				setToken(res.data.token);
				setIsLoading("false");
				history.push("/");
			})
			.catch(err => {
				setError(err.response.data);
				setIsLoading("false");
			});
	};

	return (
		<IonPage>
			<AnimatedPage>
				<IonHeader>
					<IonToolbar>
						<IonTitle>{t("login")}</IonTitle>
					</IonToolbar>
				</IonHeader>

				<IonContent fullscreen>
					<IonHeader collapse="condense">
						<IonToolbar>
							<IonTitle size="large">{t("login")}</IonTitle>
						</IonToolbar>
					</IonHeader>

					<IonGrid style={{ maxWidth: 500 }}>
						<IonRow>
							<IonCol
								size="12"
								style={{
									marginTop: 50,
									marginBottom: 20,
									display: "flex",
									justifyContent: "center"
								}}
							>
								<IonImg src={imgLogo} style={{ width: 200 }} />
							</IonCol>
							<IonCol size="12">
								<IonItem className="ion-no-padding">
									<IonLabel position="floating">
										{t("email")}
									</IonLabel>
									<IonInput
										placeholder={t("email") || ""}
										value={email}
										onIonInput={(e: any) =>
											setEmail(e.target.value)
										}
										onKeyUp={() => {
											setError("");
											setMsg("");
										}}
									></IonInput>
								</IonItem>
							</IonCol>
							<IonCol size="12">
								<IonItem className="ion-no-padding">
									<IonLabel position="floating">
										{t("password")}
									</IonLabel>
									<IonInput
										placeholder={t("password") || ""}
										value={password}
										type="password"
										onIonInput={(e: any) =>
											setPassword(e.target.value)
										}
										onKeyUp={() => {
											setError("");
											setMsg("");
										}}
									></IonInput>
								</IonItem>
							</IonCol>
							<IonCol
								size="12"
								style={{
									marginTop: 50
								}}
							>
								<Button
									text={t("login")}
									onClick={submitData}
									icon={logInOutline}
									disabled={isDisabled}
								></Button>
							</IonCol>
							<IonCol
								size="12"
								className="ion-text-center"
								style={{
									marginTop: 10
								}}
							>
								<LinkButton
									to="/fp"
									text={t("forgotPassword")}
								></LinkButton>
							</IonCol>
							<IonCol size="12">
								<IonText color="danger">{error}</IonText>
								<IonText color="success">{msg}</IonText>
							</IonCol>
						</IonRow>
					</IonGrid>
				</IonContent>
			</AnimatedPage>
		</IonPage>
	);
};

export default Login;
